import React, { useContext, useState } from "react";
import NavLinks from "./NavLink";
import { AuthContext } from "../context/AuthContext";
import CoPilotsDialog from "./CoPilotsDialog";
import AssistantsDialog from "./AssistantsDialog";
import OtherAIDialog from "./OtherAIDialog";

const NavLinksContainer = () => {
  const { currentUser } = useContext(AuthContext);
  const [isCoPilotsOpen, setIsCoPilotsOpen] = useState(false);
  const [isAssistantsOpen, setIsAssistantsOpen] = useState(false);
  const [isOtherAIOpen, setIsOtherAIOpen] = useState(false);

  return (
    <div className="navLinks">
      <NavLinks
        svg={
          <svg
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-4 w-4"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12 2l9 4.9V17L12 22l-9-4.9V7z" />
            <path d="M12 16.5v5.5" />
            <path d="M12 2v5.5" />
            <path d="M3.2 7L12 12l8.8-5" />
          </svg>
        }
        text="AI Agents"
        onClick={() => setIsOtherAIOpen(true)}
      />
      <NavLinks
        svg={
          <svg
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-4 w-4"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
          </svg>
        }
        text="Assistants"
        onClick={() => setIsAssistantsOpen(true)}
      />
      <NavLinks
        svg={
          <svg
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-4 w-4"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12 2l9 4.9V17L12 22l-9-4.9V7z" />
            <path d="M12 16.5v5.5" />
            <path d="M12 2v5.5" />
            <path d="M3.2 7L12 12l8.8-5" />
          </svg>
        }
        text="Prompt Library"
        onClick={() => setIsCoPilotsOpen(true)}
      />
      <AssistantsDialog
        isOpen={isAssistantsOpen}
        onClose={() => setIsAssistantsOpen(false)}
        currentUser={currentUser}
      />
      <CoPilotsDialog
        isOpen={isCoPilotsOpen}
        onClose={() => setIsCoPilotsOpen(false)}
        currentUser={currentUser}
      />
      <OtherAIDialog
        isOpen={isOtherAIOpen}
        onClose={() => setIsOtherAIOpen(false)}
      />
    </div>
  );
};

export default NavLinksContainer;
